import { Order } from './../../shared/model/order.model';

/**
 * Class used as payload by the Order Details Popup Action.
 */
export class OrderDetailsPopupActionPayload {
  order: Order;
}
